var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-edit-view"},[_c('top-bar',{attrs:{"title":"Editar Usuario"}}),_vm._v(" "),_c('scrollable-container',[_c('users-form',{ref:"form",attrs:{"old":_vm.oldUser,"is-edit":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103eaa27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/users/users-edit-view.vue
// module id = null
// module chunks = 